import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { take } from 'rxjs';

import { SpinnerService } from 'dspx-core';

import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { STATIC_PAGE_IDS } from '../../constants/app-data.constants';

import { GetStaticPageResponse } from '../../interfaces/get-static-page-response.interface';

import { ErrorService } from '../../services/error.service';
import { AppDataService } from '../../services/app-data.service';
import { HtmlHelperService } from '../../services/html-helper.service';

@Component({
  selector: 'app-static-page',
  templateUrl: './static-page.component.html'
})
export class StaticPageComponent {

  topOfPageId = 'topOfPageId';
  messageHtml = '';

  constructor(
    private router: Router,
    private spinnerService: SpinnerService,
    private errorService: ErrorService,
    private appDataService: AppDataService,
    private htmlHelperService: HtmlHelperService) {
  }

  ngOnInit(): void {
    const pageId = this.getPageIdFromRouterUrl(this.router.url);
    if (pageId) {
      this.spinnerService.showSpinner();
      this.appDataService.getData(`${API_ENDPOINTS.setting.getStaticPage}/${pageId}`, {})
        .pipe(take(1), this.errorService.errorHandler())
        .subscribe((data: GetStaticPageResponse) => {
          this.spinnerService.hideSpinner();
          this.messageHtml = data?.innerHtml;
          this.htmlHelperService.setFocusToHtmlElementById(this.topOfPageId);
        });
    }
  }

  private getPageIdFromRouterUrl(routerUrl: string): string {
    switch (routerUrl) {
      case `/${ROUTE_CONSTANTS.endOfSession}`: return STATIC_PAGE_IDS.endOfSession;
      case `/${ROUTE_CONSTANTS.collectionNotice}`: return STATIC_PAGE_IDS.collectionNotice;
      default: return null;
    }
  }
}
